<div class="instagram-callback-pagina center-center">
  <div class="instagram-callback-card container-card-generico">
    <p class="instagram-callback-texto">Conectando sua conta do Instagram...</p>
  </div>
</div>
